import { Component, HostBinding, Input } from '@angular/core';
import { CardComponent } from '../card/card.component';
@Component({
  selector: 'reference-card, app-reference-card',
  templateUrl: './reference-card.component.html',
  standalone: false,
})
export class ReferenceCardComponent extends CardComponent {
  template = 'external';
  @Input() icontype: 'default' | 'lucide' = 'default';

  @HostBinding('class.-link-reference-card') isLinkRefCard = false;

  ngOnInit() {
    if (this.to && this.to.trim().search(/(http|https):/) !== 0) {
      this.template = 'internal';
    }

    if (this.totype === 'link') {
      this.isLinkRefCard = true;
    }
  }
}
